export { default } from "./OffersList.jsx"
